import AccountProfitError from './AccountProfitError';

export default AccountProfitError;
